module.exports = __webpack_public_path__ + "static/img/post_1.d5637fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media-articles/posts/post_1.png
// module id = 8sTr
// module chunks = 0